module.exports = __webpack_public_path__ + "img/face-scream.463e2a2c.svg";